import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {CardBody} from "reactstrap";
import {Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";

/**
 * Položka menu.
 */
class MenuItem extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired, // název položky menu
        route: PropTypes.string.isRequired, // route pro přesměrování při kliknutí na položku
        subItem: PropTypes.bool, // zda se jedná o položku druhé úrovně (odsazenou), implicitně false
    };

    static defaultProps = {
        subItem: false,
    };

    redirect = (route) => {
        this.props.history.push(route);
    };

    render() {
        const {title, route, subItem, match} = this.props;
        const active = match.path.startsWith(route);
        return <CardBody className={`menu-item${active ? " active" : ""}${subItem ? " menu-subitem" : ""}`}
                          onClick={this.redirect.bind(this, route)}>
            <div>
                {subItem && <Icon icon="arrow-right"/>} {title}
            </div>
        </CardBody>
    }
}

export default withRouter(connect()(MenuItem));
